import { Stream, Text as Tx, } from "@bracket/ui";
import type { ISODateString, } from "@types";
import { DateTime, } from "luxon";
import type { FunctionComponent, } from "react";
import styled from "styled-components";



export declare type VarianceSinceProps = {
	value: string;
	since?: Date|DateTime|ISODateString;
	direction?: "column" | "row";
	epoch?: number;
};



export const VarianceSince: FunctionComponent<VarianceSinceProps> = ({
	value,
	since,
	epoch,
	direction = "row",
}: VarianceSinceProps ) => {

	const getDateTime = (): DateTime => {
		if(!since) { 
			throw new Error("VarianceSince received an unusable since value");
		}
		if(since instanceof DateTime) return since;
		if(since instanceof Date) return DateTime.fromJSDate(since);
		const result = DateTime.fromISO(since);
		if(result instanceof DateTime) return result;
		throw new Error("VarianceSince received an usuable since value");
	}

	const Brace = direction === "column" ? VBrace : HBrace;

	return (
		<Brace>
			<Tx xl bold>{value}</Tx>
			<Tx sm color="subheading">
				{since && epoch !== undefined && epoch > 1 ? `as of ${getDateTime().toLocaleString(DateTime.DATE_SHORT)}` : ""}</Tx>
		</Brace>
	);

}


const HBrace = styled(Stream)`
	gap: .5rem;
	align-items: flex-end;
	@media(max-width: 1024px) {
	flex-direction: column;
		align-items: flex-end;
		justify-content: flex-end;
		h6 {
			display: flex;
			align-items: flex-end;
			justify-content: flex-end;
		}
	}
`

const VBrace= styled.div`
	display: flex;
	flex-direction: column;
	gap: .5rem;
`
